import CollectImportModal from './CollectImportModal'

export default CollectImportModal
